import { useState, useCallback } from 'react';

export const useCableSelection = (cables) => {
  const [isSelectionModeEnabled, setIsSelectionModeEnabled] = useState(false);
  const [selectedCables, setSelectedCables] = useState(new Set());

  const toggleCableSelection = useCallback((originalIndex) => {
    setSelectedCables(prev => {
      const newSet = new Set(prev);
      if (newSet.has(originalIndex)) {
        newSet.delete(originalIndex);
      } else {
        newSet.add(originalIndex);
      }
      return newSet;
    });
  }, []);

  const selectAllCables = useCallback(() => {
    const allIndexes = new Set(cables.map((_, index) => index));
    setSelectedCables(allIndexes);
  }, [cables]);

  const deselectAllCables = useCallback(() => {
    setSelectedCables(new Set());
  }, []);

  return {
    isSelectionModeEnabled,
    setIsSelectionModeEnabled,
    selectedCables,
    toggleCableSelection,
    selectAllCables,
    deselectAllCables,
  };
};
